<template>
  <div id="enterpriseDeptDoc" style="height: 100%">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "EnterpriseDeptDoc"
};
</script>

<style></style>
